import { HTMLAttributes, PropsWithChildren, ReactNode } from 'react';

interface Root extends PropsWithChildren<HTMLAttributes<HTMLDivElement>> {
  children: ReactNode;
}

export function Root({ children, className, ...rest }: Root) {
  return (
    <div
      className={`bg-white gap-0 p-0 border rounded-md ${className || ''}`}
      {...rest}>
      {children}
    </div>
  );
}
